import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { EventService } from '../../services/event.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrl: './about.component.scss'
})
export class AboutComponent {
 currentLanguage = '';
   isMobile: boolean = false;
   windowSize: number = 0;
  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private translate: TranslateService,
    private eventService: EventService,
  ) {
    this.currentLanguage = this.translate.currentLang;
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.currentLanguage = params.lang;
    });

  }

   ngAfterViewInit(): void {
     if (isPlatformBrowser(this._platformId)) {
       this.windowSize = window.innerWidth;
       this.isMobile = this.windowSize <= 1024 ? true : false;
  
     }
   }
   navigateToPage(section: string): void {
   this.eventService.redirectTosection(section);
  }
}
